import React from 'react';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import Ticker from 'react-ticker';

import './VideoFooter.css';

const VideoFooter = ({ channel, description, song }) => {
  return (
    <div className="videoFooter">
      <div className="videoFooter__text">
        <h3>@{channel}</h3>
        <p>{description}</p>
        <div className="videoFooter__ticker">
          <MusicNoteIcon className="videoFooter__icon" />
          <Ticker mode="smooth" speed={7}>
            {({ index }) => <p>{song}</p>}
          </Ticker>
        </div>
      </div>
      <img
        className="videoFooter__record"
        alt="record-disc"
        src="https://static.thenounproject.com/png/934821-200.png"
      />
    </div>
  );
};

export default VideoFooter;
